import React from 'react';
import { message } from 'antd';
import { duplicateStore } from 'api/store';
import { Store } from 'api/types/store';
import StoreModal, { StoreModalProps } from '../StoreModal';
import { getInitialValuesFromStore } from '../../StoreBaseForm/utils';
import { StoreSource, useAnalytics } from 'analytics';

interface Props extends Omit<StoreModalProps, 'onSubmit'> {
  onSuccess?: (store: Store) => void;
  store: Store;
}

export default function DuplicateStore({ onSuccess = () => null, store, ...rest }: Props) {
  const capture = useAnalytics();

  const handleSubmit = (values) => {
    return duplicateStore({ storeId: store.id, ...values })
      .then((res) => {
        if (res.ok) {
          capture('store_created', { store_id: res.data?.id, source: StoreSource.duplicate });
          onSuccess(res.data);
          return;
        }
        message.error(res.errors.nonFields?.[0]);
      })
      .catch(() => message.error('Ups there was an error, please try it later!'));
  };

  return (
    <StoreModal
      title="Duplicate store"
      initialValues={getInitialValuesFromStore(store)}
      onSubmit={handleSubmit}
      mode="duplicate"
      {...rest}
    />
  );
}
